// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Pww3U","header":"MergedInvoice_header__1MiC5"};